const messages: Record<string, string> = {
	'blockedByDevice.headline': 'Use a smartphone',
	'blockedByDevice.paragraph.first': 'This link can only be used on smartphones.',
	'blockedByDevice.paragraph.second':
		'A quick tip: when opening the link, you should be near the vehicle and have your documents ready.',
	'button.continue': 'Continue',
	'button.next': 'Continue',
	'review.button.next': 'Complete',
	'button.photo.take': 'Take photo',
	'onboardingStart.headline': 'Hello! Check your information so we can begin.',
	'onboardingStart.plateNumber': 'Plate number:',
	'onboardingStart.damageNumber': 'Policy number:',
	'onboardingStart.timeout': 'This link will be active until ',
	'button.start': 'Start',
	poweredBy: 'Powered by <ce>ControlExpert</ce>, a <solvd>Solvd</solvd> group company',
	'onboarding.headline': 'Ready to start your digital inspection?',
	'onboarding.paragraph': 'Before starting the process, please consider the following:',
	'onboarding.documents': "Have the keys and the vehicle's registration card available.",
	'onboarding.camera': 'Photos can only be taken using your smartphone camera.',
	'onboarding.internet': 'Be in a place with good lighting and a strong internet connection.',
	'onboarding.vehicle':
		'Ensure the vehicle is clean, accessible from all angles, and that all windows are closed.',
	'onboarding.terms.before': 'Before beginning, please confirm the following:',
	'onboarding.terms.url': 'I agree with <tclink>Terms and conditions</tclink>.',
	'vehicleFrontLeftPerspectiveImage.title': 'Photo of the vehicle front left',
	'vehicleFrontLeftPerspectiveImage.description':
		'Take photo of the front left diagonal, ensuring the entire car is in the frame and the license plate is visible.',
	'vehicleRearLeftPerspectiveImage.title': 'Photo of the vehicle rear left',
	'vehicleRearLeftPerspectiveImage.description':
		'Take photo of the rear left diagonal, ensuring the entire car is in the frame and the license plate is visible.',
	'vehicleRearRightPerspectiveImage.title': 'Photo of the vehicle rear right',
	'vehicleRearRightPerspectiveImage.description':
		'Take photo of the rear right diagonal, ensuring the entire car is in the frame and the license plate is visible.',
	'vehicleFrontRightPerspectiveImage.title': 'Photo of the vehicle front right',
	'vehicleFrontRightPerspectiveImage.description':
		'Take photo of the front right diagonal, ensuring the entire car is in the frame and the license plate is visible.',
	'windshieldImage.title': 'Windshield image',
	'windshieldImage.description':
		'Capture an photo of the windshield, ensuring the entire glass area and its details are clearly visible.',
	'vinPicture.title': 'Photo of the VIN number',
	'vinPicture.description':
		'Take a close-up photo of the Vehicle Identification Number (VIN) area, ensuring all characters are legible.',
	'button.hint': "Where's my VIN number located?",
	'photo.deleteConfirmation.title': 'Are you sure you want to delete the photo?',
	'photo.deleteConfirmation.description':
		'If you delete the photo, you will be asked to take a new one.',
	'photo.deleteConfirmation.cancel': 'Cancel',
	'photo.deleteConfirmation.confirm': 'Delete photo',
	'hint.vin.title': 'Possible VIN locations',
	'hint.vin.description': 'It can typically be found in those 4 locations:',
	'hint.vin.location1': "On the dashboard, visible through the windshield on the driver's side.",
	'hint.vin.location2': "On the driver's side door frame, near the latch.",
	'hint.vin.location3': 'In the engine bay, often on a metal plate.',
	'hint.vin.location4': 'Front end of frame (older vehicles).',
	'overallDashboardImage.title': 'Overall dashboard image',
	'overallDashboardImage.description':
		'Capture an overall photo of the dashboard, making sure all controls and features are fully in view.',
	'dashboardMileage.title': 'Photo of the odometer',
	'vehicleMileage.description':
		'Capture a photo of the odometer, ensuring that the digital reading is in sharp focus and completely legible.',
	'dashboardMileage.paragraph.first': 'Enter the vehicle mileage.',
	'dashboardMileage.placeholder.updated': 'insert mileage (km)',
	'thanks.headline.first': 'Photos received successfully!',
	'thankYou.message': 'Your request is being reviewed by our technical team.',
	'feedback.title': 'We would appreciate your feedback.',
	'feedback.message':
		'On a scale of 0 to 5, how would you rate your experience having your digital inspection done with us?',
	'feedback.helpImprove': 'Help us improve (optional):',
	'feedback.button.send': 'Send the opinion',
	'feedback.error.maxLength': 'Feedback cannot exceed more than 500 characters.',
	'review.title': 'Summary of your digital inspection',
	'review.paragraph.first':
		'Before finishing, please verify that all information is correct.<br/><br/>After clicking "Complete", we will confirm your photos and information.',
	'review.stepDescription.questions': 'Vehicle information',
	'review.stepDescription.group.perspectiveImages': 'Vehicle overview photos',
	'review.stepDescription.group.additionalImages': 'Additional pictures',
	'review.stepDescription.vehicleFrontLeftPerspective': 'Photo of the vehicle front left',
	'review.stepDescription.vehicleRearLeftPerspective': 'Photo of the vehicle rear left',
	'review.stepDescription.vehicleRearRightPerspective': 'Photo of the vehicle rear right',
	'review.stepDescription.vehicleFrontRightPerspective': 'Photo of the vehicle front right',
	'review.stepDescription.windshield': 'Windshield image',
	'review.stepDescription.vinPicture': 'Photo of the VIN number',
	'review.stepDescription.overallDashboard': 'Overall dashboard image',
	'review.stepDescription.mileage': 'Photo of the odometer',
	'timeout.headline.first': 'The requested case was not found.',
	'timeout.paragraph.first': 'Your case has expired or the link you accessed is incorrect.',
	'photoUploading.title': 'Uploading',
	'photoAnalyzing.title': 'Analyzing',
	'photoLoading.title': 'Loading',
	'camera.darkWarning':
		'The environment is potentially too dark — please improve the lighting for better photo quality.',
	'landscapeModeDetected.title': 'Auto-rotate enabled',
	'landscapeModeDetected.text':
		'Please disable auto-rotate on your device for a better camera experience.',
	'validationContainer.correct': 'Correct',
	'button.changeImage': 'Change the photo',
	'button.acceptImage': 'Accept the photo',
	'button.acceptMileage': 'Confirm',
	'button.anotherImage': 'Take another photo',
	'invalidFile.size.title': 'Incorrect photo size',
	'invalidFile.size.description': 'The photo size is bigger than the maximum required.',
	'invalidFile.extension.title': 'File type is not supported',
	'invalidFile.extension.description':
		'The specified file type is not supported. Supported file types: .jpg, .jpeg, .jfif, .heic, .heif, .png and .bmp.',
	'connectionError.title': 'Connection error',
	'connectionError.description': 'Connection error. Please upload picture again.',
	'missingPhoto.title': 'Missing photo',
	'missingPhoto.description':
		'It seems that a photo is missing. Please add the missing photo to proceed.',
};

export default messages;
